import { useContext, useEffect, useRef, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';

function useRetrieve3DSToken() {
  const [fault, setFault] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestRetrieve3DSToken = (newRequestData) => {
    WebApi.subscriber({
      callName: 'Retrieve3DSToken',
      keyFactors: ['Retrieve3DSToken'],
      forceRefresh: true,
      payload: newRequestData,
    })
      .then((response) => {
        if (isMounted.current) {
          const tokenResponse = response.data;
          setUiModel({
            tokenResponse,
          });
        }
      })
      .catch((error) => {
        console.warn({ error });
        const code = error?.data?.Code;
        let errorMsg;
        if (!code) {
          const unknownFault = generateUnhandledFault(error.data);
          errorMsg = translateFault(unknownFault).translatedMessage;
          setFault(errorMsg);
        } else {
          errorMsg = translateFault(error.data).translatedMessage;
          setFault(errorMsg);
        }
      });
  };
  return [uiModel, fault, requestRetrieve3DSToken];
}

export { useRetrieve3DSToken };
export default useRetrieve3DSToken;
